<form class="kLoginForm" [formGroup]="_resetPasswordForm">
  <ng-container *ngIf="!passwordRestored">
    <h1>
      {{ 'app.login.restorePassword.welcome' | translate }}<br />
      {{ 'app.login.restorePassword.selectPassword' | translate }}
    </h1>

    <div>
      <input
        pInputText
        appPreventPasswordAutofill
        type="password"
        autocomplete="off"
        [placeholder]="'app.login.restorePassword.placeholder.new' | translate"
        [formControl]="_newPasswordField"
        [class.has-error]="_showError(_newPasswordField) || _passwordsDontMatch || _passwordStructureInvalid"
        [kTooltip]="_getClientValidationMessage(_newPasswordField) || _passwordStructureInvalidMessage | translate"
        placement="right"
      />
    </div>

    <div>
      <input
        pInputText
        appPreventPasswordAutofill
        type="password"
        autocomplete="off"
        [placeholder]="'app.login.restorePassword.placeholder.confirm' | translate"
        [formControl]="_repeatPasswordField"
        [class.has-error]="_showError(_repeatPasswordField) || _passwordsDontMatch"
        [kTooltip]="_getClientValidationMessage(_repeatPasswordField) | translate"
        placement="right"
      />
    </div>

    <p
      *ngIf="(_repeatPasswordField.touched || _formSent) && _showError(_passwords)"
      class="kErrorMessage"
      [innerHTML]="_getClientValidationMessage(_passwords) | translate"
    ></p>
    <p
      *ngIf="errorMessage && !_passwordStructureInvalid && _resetPasswordForm.pristine"
      class="kErrorMessage"
      [innerHTML]="errorMessage | translate"
    ></p>

    <div>
      <button
        class="kButtonDefault"
        pButton
        [label]="_sendBtnText | translate"
        (click)="_resetPassword()"
        [disabled]="inProgress"
      ></button>
    </div>
  </ng-container>

  <ng-container *ngIf="passwordRestored">
    <h1 class="kPasswordRestoredMessage">{{ 'app.login.restorePassword.restored' | translate }}</h1>

    <div>
      <button
        class="kButtonDefault"
        pButton
        [label]="'app.common.ok' | translate"
        (click)="returnToLogin.emit()"
      ></button>
    </div>
  </ng-container>
</form>
